import { useState, createContext, useEffect } from 'react';

const WindowSizeContext = createContext({});

function WindowSizeProvider({ children }) {
  const [windowWidth, setWindowWidth] = useState(window?.innerWidth ?? 1);
  const [windowHeight, setWindowHeight] = useState(window?.innerHeight ?? 1);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window?.innerWidth ?? 1);
      setWindowHeight(window?.innerHeight ?? 1);
    };
    window.addEventListener('resize', handleResize);
    return () => { window.removeEventListener('resize', handleResize); };
  }, []);

  return <WindowSizeContext.Provider value={{ windowWidth, windowHeight, smallScreen: windowWidth < 1000 }}>{children}</WindowSizeContext.Provider>
}

export { WindowSizeContext, WindowSizeProvider };